import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";

export class AgentsDisplayListCtrl implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;

  onChange: Function;

  private agentsRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $agents: $agentsFactory, private $log) {
  }

  $onInit() {
    this.agentsRef = this.$agents();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.agentsRef.$asyncValues(ids)
        .then((agents) => {
          this.displayItems = agents;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./agents-display-list.html').default,
    controller: AgentsDisplayListCtrl
  });
